<div class="container mt-4">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Rotinas</li>
    </ol>
  </nav>

  <div class="list-header">
    <div class="list-header__title">
      <h1 class="mb-0">Lista de Rotinas</h1>
      <span class="result-badge" *ngIf="totalElements > 0">{{ totalElements }} registros</span>
    </div>
    <button mat-raised-button color="primary" *ngIf="isAdmin" (click)="router.navigate(['/routines/create'])">
      <mat-icon>add</mat-icon>
      Nova Rotina
    </button>
  </div>

  <!-- Filtro -->
  <mat-form-field appearance="outline" class="filter-field">
    <mat-label>Buscar rotina</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Digite para filtrar..." />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <!-- Tabela -->
  <div class="table-container mat-elevation-z2">
    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="loading">
      <mat-spinner diameter="48"></mat-spinner>
    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" matSort class="w-100">
        <!-- Nome -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
          <td mat-cell *matCellDef="let routine">
            <span class="cell-text" [matTooltip]="routine.name">{{ routine.name }}</span>
          </td>
        </ng-container>

        <!-- Cargo -->
        <ng-container matColumnDef="responsibilityName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Cargo</th>
          <td mat-cell *matCellDef="let routine">
            <span>{{ routine.responsibility?.name }}</span>
          </td>
        </ng-container>

        <!-- Ações -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-header">Ações</th>
          <td mat-cell *matCellDef="let routine" class="actions-cell">
            <button
              mat-icon-button
              color="primary"
              *ngIf="isAdmin || isManager || isSupervisor"
              (click)="onEdit(routine)"
              matTooltip="Editar"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" *ngIf="isAdmin" (click)="onDelete(routine)" matTooltip="Desativar">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="table-row"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell empty-state" [attr.colspan]="displayedColumns.length">
            <img src="assets/img/folder.png" alt="Nenhum resultado" width="80" />
            <p class="empty-state__text">Nenhuma rotina encontrada.</p>
            <button mat-stroked-button color="primary" *ngIf="isAdmin" (click)="router.navigate(['/routines/create'])">
              Criar primeira rotina
            </button>
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="currentPage"
      [pageSizeOptions]="[10, 20, 50]"
      showFirstLastButtons
      aria-label="Selecionar página"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </div>
</div>
